export default {
  'footer.agreement': 'Legal Agreement',
  'footer.userAgreement': 'User Service Agreement',
  'footer.policy': 'Privacy Policy',

  'footer.community': 'Community',
  'footer.account': 'Official Account',
};
